export default __webpack_public_path__ + "static/media/dongle_baby.be57d49f.png";